class PropertySaveController {

    constructor($rootScope, $state, access, eventsService) {
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.access = access;
        this.eventsService = eventsService;
    }

    $onInit() {
        this.activeTab = 'property';

        this.eventsService.collectCategories().then(response => {
            this.categories = response;
        });
    }
}

PropertySaveController.$inject = [ '$rootScope', '$state', 'access', 'eventsService' ];

export default PropertySaveController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/controllers/property.save.controller.js